import type { Service } from '../types';

export const services: Service[] = [
  {
    id: "video-produksiyon",
    slug: "video-produksiyon",
    title: "Film ve Video Prodüksiyon",
    metaTitle: "Video Prodüksiyon & Reklam Filmi Çekimi - WE24 Agency İstanbul",
    metaDescription: "15 yılı aşkın deneyimle kurumsal fabrika tanıtım filmleri, televizyon reklamları, belgesel, müzik video klipleri ve lisanslı drone çekimlerini sinematik 4K/8K kalitede üretiyoruz.",
    keywords: [
      "video prodüksiyon istanbul",
      "tanıtım filmi çekimi",
      "kurumsal reklam filmi",
      "fabrika tanıtım filmi",
      "drone çekimi istanbul",
      "müzik video klip çekimi",
      "360 derece video prodüksiyon",
      "endüstriyel tanıtım filmi"
    ],
    shortDescription: "Fikirlerinizi ekrana taşıyan reklam, tanıtım, fabrika, belgesel ve müzik videolarını sinematik kalitede üretiyoruz.",
    fullDescription: "WE24 Agency olarak, 15 yılı aşan set ve prodüksiyon tecrübemizle markanızın vizyonunu, üretim gücünü ve hikâyesini en etkili görsel dille ekrana taşıyoruz. Senaryo geliştirmeden cast ve mekân keşfine, SHGM lisanslı 4K/5.1K drone uçuşlarından son teknoloji sinema kameralarına kadar tüm prodüksiyon aşamalarını kendi çekirdek ekibimiz ve ekipman parkurumuzla yönetiyoruz.",
    subservices: [
      "Kurumsal ve Endüstriyel Fabrika Tanıtım Filmleri",
      "Televizyon ve Dijital Reklam Filmleri",
      "Müzik Video Klip Prodüksiyonu",
      "Lisanslı Havadan Drone Video ve Fotoğraf Çekimi",
      "360 Derece Video ve VR / AR Deneyimleri",
      "Etkinlik, Zirve ve Lansman Aftermovie Filmleri"
    ],
    subserviceItems: [
      {
        title: "Kurumsal ve Fabrika Tanıtım Filmi",
        slug: "tanitim-filmi",
        description: "Sanayi tesisleri, teknoloji merkezleri ve kurumsal markalar için üretim süreçlerini, kalite standartlarını ve global vizyonu dinamik sinema diliyle anlatan prestijli filmler.",
        keywords: ["fabrika tanıtım filmi", "kurumsal film çekimi", "endüstriyel tanıtım videosu"]
      },
      {
        title: "Televizyon ve Dijital Reklam Filmleri",
        slug: "reklam-filmi",
        description: "Ulusal TV kanalları ve dijital platformlar (YouTube, Meta, TikTok) için hedef kitleyi harekete geçiren, yüksek prodüksiyon değerli ve yaratıcı senaryolu reklam filmleri.",
        keywords: ["reklam filmi prodüksiyonu", "tv reklam çekimi", "dijital reklam videosu"]
      },
      {
        title: "Müzik Video Klip Prodüksiyonu",
        slug: "muzik-video-klip",
        description: "Sanatçılar ve müzik şirketleri için şarkının ruhunu yansıtan sanatsal yönetmenlik, dinamik set ışıklandırması ve sinematik kurguyla hazırlanan video klipler.",
        keywords: ["klip çekimi istanbul", "müzik videosu prodüksiyonu", "profesyonel klip yönetmeni"]
      },
      {
        title: "Lisanslı Havadan Drone Çekimi",
        slug: "havadan-drone-video",
        description: "SHGM onaylı ticari İHA pilotlarımız ve 5.1K/4K sinema drone filomuz ile fabrikalar, araziler, mimari yapılar ve etkinlikler için nefes kesici hava görüntüleri.",
        keywords: ["drone video çekimi", "havadan fabrika çekimi", "lisanslı iha pilotu istanbul"]
      },
      {
        title: "360 Derece Video ve VR / AR",
        slug: "360-vr-video",
        description: "İzleyiciye mekânın içindeymiş hissi veren 360 derece interaktif video çekimleri, sanal turlar ve fuarlar için artırılmış/sanal gerçeklik görsel deneyimleri.",
        keywords: ["360 derece video", "sanal tur çekimi", "vr video prodüksiyon"]
      },
      {
        title: "Etkinlik & Lansman Aftermovie",
        slug: "etkinlik-aftermovie",
        description: "Ürün lansmanları, uluslararası kongreler, ödül törenleri ve festivallerin coşkusunu, önemli anlarını ve marka prestijini özetleyen dinamik özet filmler.",
        keywords: ["etkinlik video çekimi", "aftermovie prodüksiyon", "lansman videosu"]
      }
    ],
    deliverables: [
      "4K / 8K Cinema ProRes & Master Video Dosyaları",
      "Sosyal Medya Formatları (9:16 Reels/Shorts/TikTok, 1:1 Kare, 16:9 Yatay)",
      "Teaser ve 15/30 Saniyelik Reklam Kesitleri",
      "Yüksek Çözünürlüklü Set ve Sahne Fotoğraf Arşivi",
      "Çok Dilli Profesyonel Seslendirme (Native Voiceover) ve Altyazı Paketleri"
    ],
    process: [
      "Brifing & Strateji: Marka hedefleri, hedef kitle ve iletilmek istenen temel mesaj analiz edilir.",
      "Kreatif Senaryo & Storyboard: Çekim planları, sahne akışı ve görsel dil önceden tasarlanır.",
      "Pre-Prodüksiyon (Ön Hazırlık): Mekân keşfi, yasal izinler, oyuncu seçimi, ekipman ve ışık planlaması tamamlanır.",
      "Prodüksiyon (Set & Çekim): Yönetmen, görüntü yönetmeni ve profesyonel set ekibiyle çekimler gerçekleştirilir.",
      "Post-Prodüksiyon & Teslimat: Kurgu, renk düzenleme (color grading), ses miksajı ve revizyon süreci tamamlanarak teslim edilir."
    ],
    techSpecs: [
      {
        category: "Kamera & Optik Sistemler",
        items: ["RED Digital Cinema, ARRI & Sony FX Cinema Kameralar", "Prime Cine Lens Setleri & Anamorfik Lensler", "Kablosuz Video Aktarım & Reji Monitörleri (Teradek)"]
      },
      {
        category: "Işık & Hareket Sistemleri",
        items: ["Aputure & ARRI Profesyonel LED ve HMI Işık Setleri", "DJI Ronin Gimbal, Steadicam & Ağır Hizmet Dolly Sistemleri", "SHGM Onaylı Lisanslı 4K/5.1K Drone Filosu"]
      },
      {
        category: "Ses & Kayıt Altyapısı",
        items: ["Sennheiser & Rode Kablosuz Yaka Mikrofonları", "Boom Mikrofon ve Çok Kanallı 32-bit Float Ses Kayıtçıları"]
      }
    ],
    articleSections: [
      {
        heading: "Markanız İçin Neden Profesyonel Video Prodüksiyonu?",
        content: "Dijital çağda tüketici dikkatini yakalamanın ve marka güveni tesis etmenin en güçlü yolu yüksek kaliteli video içerikleridir. Sıradan stok çekimler yerine; kurumunuzun gerçek tesislerini, insan kaynağını, teknolojisini ve üretim kabiliyetini yansıtan sinematik bir tanıtım filmi, müşterilerinizin ve yatırımcılarınızın zihninde kalıcı bir liderlik algısı yaratır.",
        subPoints: [
          "Dönüşüm Oranlarını Katlar: Video içeren açılış sayfaları ve tanıtımlar, satın alma ve teklif alma kararlarını %80'e kadar hızlandırır.",
          "Kurumsal İtibarı Somutlaştırır: Üst düzey sinematografi, markanızın kalite standartlarının doğrudan bir kanıtı olarak algılanır.",
          "Global İhracatta En Güçlü Silahınızdır: Çok dilli altyazı ve yerel seslendirmelerle uluslararası fuar ve B2B temaslarda firmanızı en etkili şekilde tanıtır."
        ]
      },
      {
        heading: "Endüstriyel Tesis ve Fabrika Tanıtım Filmlerinde Uzmanlık",
        content: "Sanayi kuruluşları ve ihracatçı firmalar için geliştirdiğimiz özel endüstriyel çekim metodolojisi ile; robotik hatlarınızı, laboratuvarlarınızı, kalite kontrol süreçlerinizi ve lojistik gücünüzü dinamik bir sinema diliyle belgeliyoruz. İş güvenliği (İSG) standartlarına %100 uyumlu çalışan profesyonel set ekibimiz, fabrika üretim akışınızı aksatmadan çekimleri tamamlar."
      }
    ],
    faqs: [
      {
        question: "Bir kurumsal tanıtım filminin çekimi ve teslimi ne kadar sürer?",
        answer: "Projenin kapsamına bağlı olarak çekimler genellikle 1 ila 3 set günü sürer. Çekim sonrasında kurgu, renk ve ses revizyonları dahil olmak üzere nihai teslimat ortalama 10-15 iş günü içinde tamamlanır."
      },
      {
        question: "Havadan drone çekimleri için gerekli yasal izinleri kim alıyor?",
        answer: "Tüm hava çekimlerimiz Sivil Havacılık Genel Müdürlüğü (SHGM) onaylı, ticari İHA pilot lisansına sahip ekibimiz tarafından yürütülür. Gerekli uçuş izinleri, mülki idare bildirimleri ve sigorta süreçleri WE24 Agency tarafından eksiksiz yönetilir."
      },
      {
        question: "Videoların farklı dillerde versiyonları hazırlanabilir mi?",
        answer: "Evet; İngilizce, Almanca, Fransızca, Arapça, Rusça gibi talep ettiğiniz tüm dillerde yerel seslendirme sanatçıları (native voiceover) ve hedef dile uygun altyazı paketleri sunuyoruz."
      }
    ],
    icon: "Video"
  },
  {
    id: "canli-yayin-program",
    slug: "canli-yayin-program",
    title: "Canlı Yayın ve Reji Prodüksiyonu",
    metaTitle: "Çok Kameralı Canlı Yayın & Reji Hizmetleri - WE24 Agency İstanbul",
    metaDescription: "Lansman, kongre, e-spor turnuvaları ve kurumsal etkinlikler için 4K/HD çok kameralı reji, simultane çeviri ve çoklu platform (Simulcast) yayın altyapısı.",
    keywords: [
      "canlı yayın prodüksiyonu istanbul",
      "çok kameralı reji kiralama",
      "e spor canlı yayın",
      "hibrit etkinlik canlı yayın",
      "lansman canlı yayın hizmeti",
      "simultane canlı yayın"
    ],
    shortDescription: "Çok kameralı reji altyapımızla lansmanları, etkinlikleri ve e-spor turnuvalarını dijital platformlara kesintisiz taşıyoruz.",
    fullDescription: "Fiziki sınırları kaldırıyor, etkinliklerinizi tüm dünyaya televizyon yayıncılığı standartlarında canlı olarak aktarıyoruz. Çok kameralı 4K reji masamız, anlık alt yazı ve grafik paketlerimiz, simultane tercüme ses kanallarımız ve yedekli internet altyapımızla dijital dünyada kusursuz bir canlı yayın deneyimi sunuyoruz.",
    subservices: [
      "Çok Kameralı Canlı Yayın ve Reji Yönetimi",
      "Ürün Lansmanları, Basın Toplantıları ve Zirveler",
      "E-Spor Turnuvaları ve Gaming Canlı Yayın Prodüksiyonu",
      "Çoklu Platform Yayını (Simulcast: YouTube, LinkedIn, Twitch, Facebook)",
      "Hibrit Etkinlik Altyapısı ve İnteraktif Katılımcı Bağlantıları",
      "TV ve Dijital Format / Yarışma Stüdyo Prodüksiyonları"
    ],
    subserviceItems: [
      {
        title: "Çok Kameralı Canlı Yayın ve Reji Yönetimi",
        slug: "reji-canli-yayin",
        description: "ATEM 4K reji mikserleri, telsiz kameralar, reji içi anons ve profesyonel görüntü yönetimiyle TV yayın kalitesinde çok kameralı canlı akış.",
        keywords: ["reji canlı yayın", "çok kameralı çekim", "canlı yayın prodüksiyon"]
      },
      {
        title: "E-Spor & Gaming Turnuva Yayınları",
        slug: "espor-gaming-yayin",
        description: "Kristal Piksel, TaleWorlds ve büyük oyun finallerinde kanıtlanmış; anlık oyun içi skor tabloları, oyuncu kameraları ve dinamik spiker masası prodüksiyonu.",
        keywords: ["espor canlı yayın", "gaming turnuva prodüksiyonu", "twitch yayın altyapısı"]
      },
      {
        title: "Hibrit Etkinlik & Uluslararası Zirveler",
        slug: "hibrit-etkinlik-zirve",
        description: "Salondaki fiziksel izleyiciler ile dünyanın dört bir yanındaki online katılımcıları çift yönlü video, anlık oylama ve soru-cevap ile buluşturan altyapı.",
        keywords: ["hibrit kongre yayını", "online zirve prodüksiyonu", "zoom canlı yayın entegrasyonu"]
      },
      {
        title: "Çoklu Platform Eşzamanlı Yayın (Simulcast)",
        slug: "simulcast-yayin",
        description: "Tek bir yayın akışını aynı anda YouTube, LinkedIn Live, Twitter (X), Facebook ve özel web portallarına kayıpsız ve gecikmesiz olarak dağıtma.",
        keywords: ["simulcast yayın", "çoklu platform yayını", "youtube linkedin canlı yayın"]
      },
      {
        title: "Stüdyo Programcılığı & Talk Show Formatları",
        slug: "studyo-programciligi",
        description: "YouTube ve TV formatları için özel stüdyo dekoru, profesyonel reji, prompter desteği ve dinamik jenerik/alt yazı entegrasyonu.",
        keywords: ["stüdyo program çekimi", "youtube talk show prodüksiyon", "webcast stüdyo kiralama"]
      }
    ],
    deliverables: [
      "Kesintisiz Yüksek Bitrate Canlı Yayın Akışı (1080p60 / 4K)",
      "Ham ve Grafik Ekli Master Kayıtlar (Clean & Dirty PGM)",
      "Yayın Anı Kısa Özet (Highlight / Short) Video Kesitleri",
      "Detaylı İzleyici Sayısı, Etkileşim ve Analitik Raporu"
    ],
    process: [
      "Mekân Keşfi & İnternet Testi: Yayın yapılacak alanın ışık, ses ve upload hız kapasitesi test edilir.",
      "Reji & Sahne Kurulumu: Kameralar, telsiz ses sistemleri, reji mikseri ve grafik sunucuları kurulur.",
      "Yayın Provası & Ses Ayarı: Konuşmacılarla ses dengeleri, jenerikler ve video geçiş provaları yapılır.",
      "Canlı Yayın Yönetimi: Reji yönetmeni, teknik yönetmen ve kamera ekibi yayını canlı olarak yönetir.",
      "Yayın Sonu Arşivleme: Tüm kameraların ISO kayıtları ve mikslenmiş PGM master kayıtları anında teslim edilir."
    ],
    techSpecs: [
      {
        category: "Reji & Görüntü Mikserleri",
        items: ["Blackmagic Design ATEM 4K Prodüksiyon Switcher", "vMix 4K Profesyonel Yayın Sunucuları", "NDI ve SDI Düşük Gecikmeli Video İletim Hatları"]
      },
      {
        category: "Kamera & Telsiz Aktarım",
        items: ["Sony FX9, FX6 & FX3 Cinema Kameralar", "PTZ Uzaktan Kontrollü Robotik Kameralar", "Teradek Bolt 4K Sıfır Gecikmeli Kablosuz Vericiler"]
      },
      {
        category: "Ses & İnternet Yedekleme",
        items: ["Behringer & Yamaha Dijital Ses Mikserleri", "Dante Dijital Ses Protokolü", "Multi-WAN 4G/5G Bonding İnternet Yedekleme Üniteleri"]
      }
    ],
    articleSections: [
      {
        heading: "Kurumsal Canlı Yayınlarda Sıfır Hata Prensibi",
        content: "Basın toplantıları, hissedar genel kurulları veya küresel lansmanlar geri dönüşü olmayan anlardır. WE24 Agency, canlı yayın projelerinde çift hatlı internet yedeklemesi (bonded cellular), jeneratör destekli kesintisiz güç kaynakları ve çift reji donanımıyla çalışarak %100 yayın güvencesi sağlar.",
        subPoints: [
          "Yedekli İnternet Altyapısı: Ana hat kopsa dahi milisaniye içinde devreye giren multi-operatör bonding teknolojisi.",
          "Televizyon Standartlarında Grafik: Şirket logonuz, konuşmacı unvanları, alt bantlar ve canlı oylama sonuçları yayına anında eklenir.",
          "Etkileşimli Deneyim: İzleyicilerden gelen sorular reji tarafından elenerek sahnede moderatör ekranına canlı aktarılır."
        ]
      }
    ],
    faqs: [
      {
        question: "Yayın yapılacak alanda internet hızı yetersizse ne yapıyorsunuz?",
        answer: "Kendi bünyemizdeki taşınabilir Multi-SIM 4G/5G bonding cihazlarımız sayesinde, mekânda hiç internet olmasa bile yüksek hızlı ve kararlı yayın sinyali oluşturuyoruz."
      },
      {
        question: "Yayın sırasında simultane tercüme desteği nasıl sağlanır?",
        answer: "Fiziki tercüme kabinleri veya uzaktan bağlanan tercümanlar üzerinden dilediğiniz dilde ayrı ses kanalları oluşturup, izleyicilere seçilebilir dil seçenekleriyle yayın yapabiliyoruz."
      }
    ],
    icon: "Radio"
  },
  {
    id: "post-produksiyon",
    slug: "post-produksiyon",
    title: "Post-Prodüksiyon, Renk ve VFX",
    metaTitle: "Post Prodüksiyon, DaVinci Renk & VFX Stüdyosu - WE24 Agency",
    metaDescription: "DaVinci Resolve renk düzenleme (Color Grading), ileri düzey görsel efekt (VFX), 2D/3D hareketli grafik, sinematik kurgu ve ses miksaj stüdyosu.",
    keywords: [
      "post prodüksiyon istanbul",
      "davinci resolve renk düzenleme",
      "vfx stüdyosu istanbul",
      "video kurgu montaj",
      "3d animasyon ajansı",
      "ses tasarımı ve miksaj"
    ],
    shortDescription: "DaVinci Resolve renk düzenleme, görsel efektler, 3D animasyon ve ses tasarımı ile görüntüleri sanat eserine dönüştürüyoruz.",
    fullDescription: "Çekilen ham görüntülerin gerçek potansiyeli stüdyoda açığa çıkar. WE24 Agency post-prodüksiyon stüdyosunda; kalibre edilmiş referans monitörlerimiz, güçlü render iş istasyonlarımız ve alanında uzman kolorist, kurgu ve VFX sanatçılarımızla videolarınıza uluslararası sinema standartlarında estetik kazandırıyoruz.",
    subservices: [
      "Profesyonel Kurgu ve Montaj (Offline & Online Editing)",
      "DaVinci Resolve Sinematik Renk Düzenleme (Color Grading)",
      "VFX ve Görsel Efekt Tasarımı (CGI, Clean-up, Compositing)",
      "2D ve 3D Hareketli Grafik (Motion Graphics) & Animasyon",
      "Sinematik Ses Tasarımı, Foley ve 5.1 / Stereo Miksaj"
    ],
    subserviceItems: [
      {
        title: "Profesyonel Kurgu & Montaj",
        slug: "kurgu-montaj",
        description: "Ritim duygusu yüksek, izleyiciyi içine çeken anlatı yapısı, dinamik sahne geçişleri ve hikâyenin duygusunu zirveye taşıyan profesyonel kurgu.",
        keywords: ["video kurgu", "profesyonel montaj", "video düzenleme hizmeti"]
      },
      {
        title: "DaVinci Resolve Renk Düzenleme (Color Grading)",
        slug: "renk-duzenleme",
        description: "Flanders Scientific referans monitörlerinde RAW/Log görüntülere özel renk atmosferi, cilt tonu optimizasyonu ve sinematik renk ayrımı.",
        keywords: ["color grading istanbul", "davinci resolve renk", "sinematik renk düzenleme"]
      },
      {
        title: "VFX & Görsel Efekt Stüdyosu",
        slug: "vfx-gorsel-efekt",
        description: "Yeşil perde (green screen) birleştirme, nesne silme/clean-up, ürün dijitalleştirme, 3D parça entegrasyonu ve fotogerçekçi görsel efektler.",
        keywords: ["vfx stüdyosu", "görsel efekt yapımı", "green screen compositing"]
      },
      {
        title: "2D / 3D Animasyon & Motion Design",
        slug: "animasyon-motion-graphics",
        description: "Karmaşık teknik mekanizmaları basitleştiren 3D endüstriyel patlatma animasyonları, infografik videolar ve göz alıcı kinetik tipografiler.",
        keywords: ["3d animasyon istanbul", "motion graphics ajansı", "endüstriyel 3d modelleme"]
      },
      {
        title: "Ses Tasarımı & Mastering",
        slug: "ses-tasarimi-mastering",
        description: "Görseli tamamlayan atmosfer sesleri, foley efektleri, frekans temizliği, profesyonel ses miksajı ve EBU R128 yayın standardı mastering.",
        keywords: ["ses tasarımı", "video ses miksajı", "ses mastering"]
      }
    ],
    deliverables: [
      "Rec.709, DCI-P3 ve HDR10 Formatlarında Renk Master Dosyaları",
      "Kayıpsız ProRes 422 HQ / 4444 XQ ve H.264/H.265 Web Teslimatları",
      "Katmanlı After Effects ve Premiere Pro Proje Arşivleri",
      "Stem Ses Kanalları (Diyalog, Müzik, Efekt ayrı ayrı)"
    ],
    process: [
      "Data Yönetimi & Ingest: Çekim kartları güvenli checksum ile çift yedekli depolama sunucularına aktarılır.",
      "Kaba Kurgu (Offline): Sahne seçimi ve genel hikâye akışı oluşturularak onayınıza sunulur.",
      "İnce Kurgu & İnce Ayar: Müzik ritmi, tempo ve diyalog düzenlemeleri netleştirilir.",
      "Color Grading & VFX: DaVinci Resolve ile renk dünyası kurulur, efekt ve grafikler entegre edilir.",
      "Ses Miksajı & Master Export: Ses temizliği, foley ve müzik mikslenerek yayın formatlarında ihraç edilir."
    ],
    techSpecs: [
      {
        category: "Donanım & Donanım Altyapısı",
        items: ["DaVinci Resolve Studio & Blackmagic Advanced Panels", "Flanders Scientific & Apple XDR Kalibre Referans Monitörleri", "Yüksek Hızlı 10GbE NVMe NAS Depolama Sunucuları"]
      },
      {
        category: "Yazılım Parkuru",
        items: ["DaVinci Resolve Studio", "Adobe Creative Cloud (Premiere Pro, After Effects, Photoshop)", "Maxon Cinema 4D, Blender & Unreal Engine 5"]
      }
    ],
    articleSections: [
      {
        heading: "Renk Düzenleme (Color Grading) Neden Fark Yaratır?",
        content: "Renk düzenleme sadece görüntünün parlaklığını ayarlamak değildir; izleyicide yaratılmak istenen psikolojik etkiyi (hüzün, heyecan, güven, lüks) renk tonlarıyla inşa etme sanatıdır. Hollywood standartlarındaki renk araçlarımızla, markanızın kurumsal renk kodlarını sahnedeki ışıkla kusursuz şekilde harmanlıyoruz."
      }
    ],
    faqs: [
      {
        question: "Daha önce başka bir ekiple çekilmiş ham görüntülerimize post-prodüksiyon yapabilir misiniz?",
        answer: "Evet; farklı kameralarla (Sony, RED, ARRI, Blackmagic, Canon) çekilmiş ham Log veya RAW görüntülerinizi stüdyomuzda eşleyip kurgu, renk ve ses işlemlerini üstlenebiliriz."
      }
    ],
    icon: "Sparkles"
  },
  {
    id: "fotograf-produksiyon",
    slug: "fotograf-produksiyon",
    title: "Fotoğraf Prodüksiyonu",
    metaTitle: "Profesyonel Fotoğraf Prodüksiyonu & Çekim - WE24 Agency İstanbul",
    metaDescription: "Mimari, endüstriyel fabrika, ürün, model moda ve hava drone fotoğraf çekimlerinde yüksek çözünürlüklü kreatif fotoğrafçılık hizmetleri.",
    keywords: [
      "profesyonel fotoğraf çekimi istanbul",
      "ürün fotoğrafçılığı",
      "fabrika fotoğraf çekimi",
      "mimari fotoğrafçı",
      "moda model fotoğraf çekimi",
      "e-ticaret ürün çekimi"
    ],
    shortDescription: "Mimari mekânlardan endüstriyel tesislere, e-ticaret ürünlerinden moda ve lifestyle çekimlerine kadar yüksek çözünürlüklü fotoğraf prodüksiyonu.",
    fullDescription: "Görsel dünyada ilk izlenim saniyeler içinde oluşur. WE24 Agency fotoğraf prodüksiyonu ekibi; yüksek dinamik aralıklı profesyonel full-frame ve orta format kameralar, stüdyo ışık setleri ve ileri düzey rötuş (retouching) süreçleriyle markanızın ürünlerini, mekânlarını ve kurum kültürünü en prestijli açılardan ölümsüzleştirir.",
    subservices: [
      "Mimari & İç / Dış Mekân Fotoğraflama",
      "Endüstriyel & Tesis / Fabrika Fotoğrafçılığı",
      "Profesyonel Ürün & E-Ticaret Fotoğraf Çekimi",
      "Model, Moda ve Lifestyle Stüdyo Çekimleri",
      "Yüksek Çözünürlüklü Havadan Drone Fotoğrafçılığı"
    ],
    subserviceItems: [
      {
        title: "Mimari & Mekân Fotoğraflama",
        slug: "mimari-fotograflama",
        description: "Oteller, lüks konut projeleri, restoranlar ve şirket genel merkezleri için perspektif düzeltmeli tilt-shift lenslerle iç ve dış cephe mimari çekimleri.",
        keywords: ["mimari fotoğraf çekimi", "otel fotoğrafçılığı", "iç mekan fotoğrafçısı istanbul"]
      },
      {
        title: "Endüstriyel & Fabrika Fotoğrafçılığı",
        slug: "endustriyel-fotografcilik",
        description: "Üretim parkurları, ağır sanayi tesisleri, Ar-Ge merkezleri ve saha operasyonlarının kurumsal prestijini yansıtan katalog kalitesinde fotoğraflar.",
        keywords: ["fabrika fotoğrafçılığı", "sanayi tesisi fotoğraf çekimi", "kurumsal fotoğrafçı"]
      },
      {
        title: "Ürün & E-Ticaret Fotoğraf Çekimi",
        slug: "urun-fotografciligi",
        description: "Kozmetik, gıda, mücevher, tekstil ve endüstriyel parçalar için stüdyo ortamında gölgesiz dekupe, konsept ve ghost manken çekimleri.",
        keywords: ["ürün fotoğraf çekimi", "e-ticaret beyaz fon çekim", "kozmetik konsept çekimi"]
      },
      {
        title: "Model & Moda Fotoğraf Çekimleri",
        slug: "model-moda-fotografciligi",
        description: "Lookbook, katalog ve kampanya görselleri için cast seçimi, styling, makyaj ve stüdyo/dış mekân moda fotoğraf prodüksiyonu.",
        keywords: ["moda fotoğraf çekimi", "model stüdyo çekimi", "lookbook fotoğrafçılığı"]
      },
      {
        title: "Havadan Drone Fotoğrafçılığı",
        slug: "havadan-drone-fotograf",
        description: "Fabrika arazileri, limanlar, şantiyeler ve şehir peyzajları için yüksek çözünürlüklü RAW hava fotoğrafları ve ortofoto haritalama.",
        keywords: ["hava fotoğrafı çekimi", "drone fotoğrafçı", "arsa arazi drone fotoğrafı"]
      }
    ],
    deliverables: [
      "Yüksek Çözünürlüklü 45-60 Megapiksel Master RAW & TIFF Dosyaları",
      "Web ve Sosyal Medya İçin Optimize Edilmiş WebP ve JPEG Formatları",
      "Profesyonel High-End Retouch ve Renk Düzeltmesi Yapılmış Görseller",
      "E-Ticaret İçin Şeffaf Arka Plan (Dekupe) Dosyaları"
    ],
    process: [
      "Görsel Konsept & Moodboard: Markanın hedef kitlesine uygun ışık, renk ve kadraj konsepti planlanır.",
      "Stüdyo & Mekân Hazırlığı: Ürünler temizlenir, styling yapılır ve profesyonel ışık kurulumu tamamlanır.",
      "Tethered Canlı Çekim: Bilgisayara anlık aktarımla çekimler müşteri onaylı olarak gerçekleştirilir.",
      "High-End Retouching: Kusur temizliği, renk doğrulaması ve doku iyileştirmeleri yapılır.",
      "Formatlı Teslimat: Baskı ve dijital mecralara uygun tüm çözünürlüklerde teslim edilir."
    ],
    techSpecs: [
      {
        category: "Kamera & Lens Ekipmanı",
        items: ["Sony Alpha Yüksek Çözünürlüklü Full-Frame Gövdeler", "Sony G-Master & Canon L Serisi Prime & Tilt-Shift Lensler", "Hasselblad Orta Format Stüdyo Çözümleri"]
      },
      {
        category: "Işık & Stüdyo Ekipmanları",
        items: ["Profoto & Broncolor Profesyonel Paraflaş Sistemleri", "Çeşitli Softbox, Octabox ve Difüzörler", "Tether Tools Canlı Monitör Aktarım Sistemleri"]
      }
    ],
    articleSections: [
      {
        heading: "Yüksek Kaliteli Fotoğrafın Dijital Satışlara Etkisi",
        content: "E-ticaret ve dijital pazarlamada müşteriler ürüne dokunamaz; sadece fotoğraflara güvenerek satın alma kararı verirler. Profesyonel stüdyo ortamında doğru ışıkla çekilmiş, ürünün dokusunu ve renk doğruluğunu yansıtan fotoğraflar, ürün iadelerini %40 azaltırken dönüşüm oranlarını 3 kata kadar artırır."
      }
    ],
    faqs: [
      {
        question: "Ürün çekimleri için ürünleri stüdyonuza mı göndermemiz gerekiyor?",
        answer: "Ürünlerinizi Şişli stüdyomuza kargolayabilir veya getirebilirsiniz. Büyük hacimli sanayi ürünleri, makineler veya yerinde çekilmesi gereken koleksiyonlar için ise mobil stüdyo ışıklarımızla tesisinize gelerek çekim yapabiliyoruz."
      },
      {
        question: "Dekupe (arka planı temizlenmiş) ürün fotoğrafları veriyor musunuz?",
        answer: "Evet; e-ticaret pazaryerleri (Amazon, Trendyol, Hepsiburada vb.) standartlarına %100 uyumlu, saf beyaz fon veya şeffaf PNG formatında dekupe teslimat yapıyoruz."
      }
    ],
    icon: "Camera"
  },
  {
    id: "dijital-ve-sosyal-medya",
    slug: "dijital-ve-sosyal-medya",
    title: "Dijital Strateji ve Sosyal Medya Yönetimi",
    metaTitle: "Sosyal Medya Yönetimi & Dijital Strateji - WE24 Agency İstanbul",
    metaDescription: "Sosyal medya hesap yönetimi, Reels & TikTok içerik üretimi, Meta & Google reklam yönetimi, YouTube SEO ve veri odaklı büyüme stratejileri.",
    keywords: [
      "sosyal medya ajansı istanbul",
      "sosyal medya yönetimi",
      "reels içerik üretimi",
      "meta reklam yönetimi",
      "youtube seo danışmanlığı",
      "dijital pazarlama ajansı"
    ],
    shortDescription: "Sosyal medya yönetimi, viral video içerikleri, performans pazarlaması ve büyüme odaklı dijital stratejiler geliştiriyoruz.",
    fullDescription: "Geleneksel sosyal medya ajanslarının ezberlerini bozuyoruz. Bir prodüksiyon ajansı olmanın verdiği görsel üstünlükle; markanıza sadece grafikler değil, yüksek kaliteli dikey videolar (Reels, TikTok, Shorts), özgün anlatımlar ve bütçenizi en yüksek ciroya dönüştüren veri odaklı performans reklamları üretiyoruz.",
    subservices: [
      "Sosyal Medya Hesap Yönetimi ve Aylık İçerik Planlama",
      "Dinamik Dikey Video ve Viral İçerik Üretimi (Reels / TikTok)",
      "Meta (Instagram & Facebook), TikTok ve Google Reklam Yönetimi",
      "YouTube Kanal Yönetimi, Video SEO ve Organik İzleyici Büyütme",
      "Influencer Pazarlaması ve Marka İş Birlikleri",
      "Topluluk Yönetimi ve İtibar / Kriz İletişimi"
    ],
    subserviceItems: [
      {
        title: "Sosyal Medya Hesap Yönetimi",
        slug: "sosyal-medya-hesap-yonetimi",
        description: "Marka diline uygun aylık editoryal içerik takvimi, profesyonel tasarım şablonları, metin yazarlığı ve topluluk etkileşimi yönetimi.",
        keywords: ["sosyal medya yönetimi", "instagram hesap yönetimi", "sosyal medya danışmanlığı"]
      },
      {
        title: "Dinamik Dikey Video & Reels Üretimi",
        slug: "dijital-icerik-uretimi",
        description: "Instagram Reels, YouTube Shorts ve TikTok algoritmalarının sevdiği, ilk 3 saniyede izleyiciyi yakalayan profesyonel kısa video prodüksiyonları.",
        keywords: ["reels çekimi", "tiktok içerik üretimi", "viral video ajansı"]
      },
      {
        title: "Performans & Sosyal Medya Reklamları",
        slug: "sosyal-medya-reklam-yonetimi",
        description: "Meta Ads Manager, Google Ads ve TikTok Ads üzerinden ROAS (reklam harcaması getirisi) odaklı hedefleme, A/B testleri ve bütçe optimizasyonu.",
        keywords: ["meta reklam yönetimi", "instagram reklam verme", "performans pazarlama ajansı"]
      },
      {
        title: "YouTube Kanal Yönetimi & Video SEO",
        slug: "youtube-kanal-yonetimi-seo",
        description: "Tıklama oranı (CTR) yüksek kapak görselleri (thumbnail), anahtar kelime etiketleme, oynatma listesi stratejisi ve kanal büyüme danışmanlığı.",
        keywords: ["youtube seo", "youtube kanal yönetimi", "youtube izlenme artırma"]
      }
    ],
    deliverables: [
      "Aylık Onaylı Sosyal Medya İçerik ve Çekim Takvimi",
      "Haftalık Yayınlanan Profesyonel Reels / TikTok Video Paketleri",
      "Meta ve Google Reklam Kampanya Kurulumları ve Optimizasyonları",
      "Aylık Ayrıntılı Etkileşim, Takipçi Artışı ve ROAS Performans Raporları"
    ],
    process: [
      "Marka & Rakip Analizi: Sektörünüzdeki fırsatlar, hedef kitlenin ilgi alanları ve rakipler incelenir.",
      "İçerik Stratejisi: Markanızın görsel dili, paylaşım sıklığı ve video konseptleri belirlenir.",
      "Aylık Stüdyo / Saha Çekimleri: Ekibimiz her ay düzenli çekimler yaparak taze video stoğu oluşturur.",
      "Yayın & Reklam Yönetimi: Tasarımlar ve videolar onayınızla yayına alınır, reklam kampanyaları optimize edilir.",
      "Analiz & Raporlama: Ay sonunda elde edilen veriler analiz edilerek sonraki ayın stratejisi güncellenir."
    ],
    techSpecs: [
      {
        category: "Prodüksiyon & Çekim Araçları",
        items: ["Mobil 4K Dikey Video Kameraları & Kablosuz Mikrofonlar", "Kompakt Hızlı Kurulum LED Işık Setleri"]
      },
      {
        category: "Yazılım & Analitik Araçları",
        items: ["Meta Business Suite & Google Analytics 4", "Semrush, TubeBuddy & VidIQ Video SEO Araçları", "Sprout Social & Hootsuite Takip Sistemleri"]
      }
    ],
    articleSections: [
      {
        heading: "Görsel Güç ile Performans Pazarlamasının Birleşimi",
        content: "Bir sosyal medya reklamının başarısını belirleyen en önemli etken %70 oranında kreatif kalitedir. Teknik olarak mükemmel hedeflenmiş bir reklam, kalitesiz bir görselle birleştiğinde bütçenizi tüketir. WE24 Agency, güçlü video prodüksiyon kabiliyetiyle hazırladığı yüksek etkileşimli reklam kreatifleri sayesinde reklam maliyetlerinizi (CPC & CPA) düşürür."
      }
    ],
    faqs: [
      {
        question: "Sosyal medya için içerik çekimlerini nerede yapıyorsunuz?",
        answer: "Kendi Şişli stüdyomuzda veya firmanızın ofis, mağaza ve fabrikalarında düzenli periyotlarla profesyonel ekipmanlarımızla çekimler gerçekleştiriyoruz."
      }
    ],
    icon: "Share2"
  },
  {
    id: "tasarim-ve-marka",
    slug: "tasarim-ve-marka",
    title: "Marka Kimliği ve Grafik Tasarım",
    metaTitle: "Kurumsal Kimlik & Grafik Tasarım Ajansı - WE24 Agency",
    metaDescription: "Logo tasarımı, kurumsal kimlik rehberi, sosyal medya tasarım şablonları, katalog & dergi mizanpajı ve ambalaj tasarımı hizmetleri.",
    keywords: [
      "kurumsal kimlik tasarımı istanbul",
      "logo tasarım ajansı",
      "katalog mizanpaj tasarımı",
      "ambalaj tasarımı",
      "sosyal medya görsel tasarımı",
      "marka kimliği oluşturma"
    ],
    shortDescription: "Logo, kurumsal kimlik, katalog, ambalaj ve dijital tasarım sistemleri ile markanıza güçlü ve akılda kalıcı bir görsel ruh kazandırıyoruz.",
    fullDescription: "Markanızın görsel imzası, müşterilerinizin zihninde bıraktığınız ilk ve en kalıcı izdir. Tipografiden renk paletine, logo geometrisinden ambalaj ve editoryal mizanpaja kadar her temas noktasında kurumunuzun prestijini ve felsefesini yansıtan zamansız tasarım sistemleri kuruyoruz.",
    subservices: [
      "Kurumsal Kimlik & Logo Tasarımı",
      "Sosyal Medya Görsel Tasarım Sistemleri",
      "Katalog, Dergi & Mizanpaj (Editoryal Tasarım)",
      "Ambalaj Tasarımı & Ürün Giydirme",
      "Fuar Standı & Çevre Grafikleri Tasarımı",
      "UI / UX Tasarım Sistemleri ve Arayüz Tasarımı"
    ],
    subserviceItems: [
      {
        title: "Kurumsal Kimlik & Logo Tasarımı",
        slug: "kurumsal-kimlik-tasarimi",
        description: "Markanızın karakterini yansıtan özgün logo, renk kodları, kurumsal font ailesi, kartvizit, antetli kağıt ve kapsamlı marka kılavuzu (Brandbook).",
        keywords: ["logo tasarımı", "kurumsal kimlik rehberi", "brandbook hazırlama"]
      },
      {
        title: "Sosyal Medya Tasarım Sistemleri",
        slug: "sosyal-medya-tasarimi",
        description: "Instagram, LinkedIn ve diğer mecralar için tutarlı, marka renkleriyle uyumlu, modern ve dikkat çekici görsel şablonlar.",
        keywords: ["sosyal medya tasarım", "instagram post şablonu", "banner tasarımı"]
      },
      {
        title: "Katalog, Dergi & Mizanpaj (Editoryal)",
        slug: "dergi-sayfa-tasarimi-mizanpaj",
        description: "Basılı ve dijital ürün katalogları, prestij dergileri, kurumsal faaliyet raporları ve broşürler için uluslararası standartlarda mizanpaj.",
        keywords: ["katalog tasarımı", "dergi mizanpaj", "faaliyet raporu tasarımı"]
      },
      {
        title: "Ambalaj & Etiket Tasarımı",
        slug: "ambalaj-tasarimi",
        description: "Rafta fark yaratan, tüketiciyi satın almaya teşvik eden, malzeme ve baskı teknikleriyle kusursuz uyumlu ambalaj çözümleri.",
        keywords: ["ambalaj tasarımı", "etiket tasarımı", "kutu tasarım ajansı"]
      }
    ],
    deliverables: [
      "Vektörel Formatlarda Logo Paketleri (AI, EPS, SVG, PDF, PNG)",
      "Kapsamlı Marka Kurumsal Kimlik Kılavuzu (Brandbook PDF)",
      "Baskıya Hazır Yüksek Çözünürlüklü Matbaa Dosyaları (CMYK + Bıçak İzi)",
      "Dijital Kullanım İçin RGB Tipografi ve İkon Setleri"
    ],
    process: [
      "Marka Konumlandırma & Araştırma: Marka değerleri, pazar trendleri ve hedef kitle algısı incelenir.",
      "Fikir & Eskiz Süreci: Kreatif direktörümüz ve tasarımcılarımız farklı konsept taslakları hazırlar.",
      "Konsept Sunumu: Seçilen güçlü alternatifler gerçek kullanım alanlarında (mockup) sunulur.",
      "Revizyon & İnce Ayar: Tercih edilen konsept üzerinden geri bildirimlerle detaylar mükemmelleştirilir.",
      "Master Teslimat: Tüm basılı ve dijital formatlar eksiksiz bir arşiv paketi olarak teslim edilir."
    ],
    techSpecs: [
      {
        category: "Tasarım Yazılımları",
        items: ["Adobe Illustrator & Photoshop", "Adobe InDesign (Editoryal Mizanpaj)", "Figma (Tasarım Sistemleri & Arayüz)"]
      }
    ],
    articleSections: [
      {
        heading: "Kurumsal Kimliğin İşletmenize Sağladığı Değer",
        content: "Tutarlı bir kurumsal kimlik, işletmenizin algılanan değerini katbekat artırır. Profesyonelce hazırlanmış bir marka kimliği; güven verir, fiyat esnekliği sağlar ve müşterilerinizi markanızın sadık savunucuları haline getirir."
      }
    ],
    faqs: [
      {
        question: "Kurumsal kimlik tesliminde hangi dosyaları alacağız?",
        answer: "Vektörel kaynak dosyalar (AI, EPS, PDF), şeffaf PNG'ler, font lisans bilgileri, renk kodları (Pantone, CMYK, RGB, HEX) ve kullanım kurallarını belirten Brandbook kılavuzunuz teslim edilir."
      }
    ],
    icon: "Palette"
  },
  {
    id: "web-ve-yazilim",
    slug: "web-ve-yazilim",
    title: "Web Geliştirme ve Özel Yazılım",
    metaTitle: "Modern Web Tasarım & Özel Yazılım Geliştirme - WE24 Agency",
    metaDescription: "Yüksek hızlı, SEO uyumlu kurumsal web siteleri, Next.js / Vite web uygulamaları, e-ticaret altyapıları ve özel yazılım çözümleri.",
    keywords: [
      "web tasarım ajansı istanbul",
      "özel yazılım geliştirme",
      "kurumsal web sitesi",
      "e-ticaret sitesi yapımı",
      "nextjs react web yazılım",
      "seo uyumlu web sitesi"
    ],
    shortDescription: "Modern teknolojilerle (React, Next.js, Vite) tasarladığımız ultra hızlı, SEO uyumlu ve dönüşüm odaklı web deneyimleri.",
    fullDescription: "Sadece güzel görünen değil; Google PageSpeed testlerinde 100 tam puan alan, mobil cihazlarda yağ gibi akan ve arama motorlarında üst sıralara tırmanan modern web uygulamaları inşa ediyoruz. Hazır ve yavaş şablonlar yerine, markanızın ihtiyaçlarına göre özel olarak kodlanmış güvenli yazılım mimarileri sunuyoruz.",
    subservices: [
      "Modern Kurumsal Web Tasarım ve Geliştirme",
      "Özel Web Uygulamaları ve SaaS Platform Geliştirme",
      "E-Ticaret Altyapıları ve Ödeme Sistemleri Entegrasyonu",
      "Mobil Uyumlu (Responsive) Arayüz ve PWA Geliştirme",
      "SEO Uyumlu Headless CMS ve İçerik Yönetim Sistemleri",
      "Masaüstü ve Mobil Özel İş Yazılımları"
    ],
    subserviceItems: [
      {
        title: "Kurumsal Web Tasarım & Yazılım",
        slug: "web-tasarim-yazilim",
        description: "Markanızın prestijini dijitale taşıyan, ultra hızlı açılan, Core Web Vitals standartlarına tam uyumlu ve modern kurumsal siteler.",
        keywords: ["kurumsal web sitesi", "web tasarım istanbul", "hızlı web yazılım"]
      },
      {
        title: "Özel Web Uygulamaları & SaaS",
        slug: "ozel-yazilim-gelistirme",
        description: "Şirket içi iş akışlarınızı otomatize eden paneller, müşteri portalları, rezervasyon/teklif motorları ve ölçeklenebilir SaaS yazılımları.",
        keywords: ["özel yazılım", "saas geliştirme", "web uygulaması yapımı"]
      },
      {
        title: "E-Ticaret Altyapıları & Entegrasyonlar",
        slug: "e-ticaret-altyapisi",
        description: "Yüksek dönüşüm oranlı sepet ve ödeme adımları, ERP/Muhasebe/Kargo API entegrasyonları ve güvenli online satış sistemleri.",
        keywords: ["e-ticaret sitesi", "online mağaza kurulumu", "ödeme sistemi entegrasyonu"]
      },
      {
        title: "Mobil Yazılım & PWA",
        slug: "mobil-yazilim",
        description: "iOS ve Android uyumlu mobil uygulamalar, Progressive Web App (PWA) çözümleri ve mobil odaklı kullanıcı deneyimi tasarımları.",
        keywords: ["mobil uygulama geliştirme", "pwa web sitesi", "mobil yazılım ajansı"]
      }
    ],
    deliverables: [
      "Tam Kaynak Kodları ve Git Deposu Erişimi",
      "PageSpeed 90+ Performans, SEO ve Erişilebilirlik Garantisi",
      "Mobil, Tablet ve Masaüstü Kusursuz Responsive Uyumluluk",
      "SSL Güvenlik, HSTS, Güvenlik Duvarı ve DDoS Koruması",
      "Kolay Yönetilebilir Yönetim Paneli ve Kullanım Eğitimi"
    ],
    process: [
      "İhtiyaç Analizi & Bilgi Mimarisi: Kullanıcı akışları, sayfa hiyerarşisi ve gerekli entegrasyonlar belirlenir.",
      "UI/UX Tel Çerçeve (Wireframe) & Tasarım: Modern ve özgün arayüz tasarımları Figma üzerinde hazırlanır.",
      "Frontend & Backend Kodlama: React / Next.js / TypeScript ile temiz ve standartlara uygun kodlama yapılır.",
      "SEO & Hız Optimizasyonu: Schema.org yapısal verileri, görseller ve kod paketleri optimize edilir.",
      "Test & Canlıya Alma: Güvenlik, hız ve çapraz tarayıcı testlerinin ardından sunucunuza sorunsuz konuşlandırılır."
    ],
    techSpecs: [
      {
        category: "Frontend Teknolojileri",
        items: ["React, Next.js, Vite, TypeScript", "Tailwind CSS Modern Tasarım Sistemi", "Framer Motion & Lucide Icons"]
      },
      {
        category: "Backend & Altyapı",
        items: ["Node.js, Express, Python / FastAPI", "PostgreSQL, MySQL, Redis, Cloudflare", "Linux / Apache / Nginx Yüksek Güvenlikli Sunucular"]
      }
    ],
    articleSections: [
      {
        heading: "Neden Hazır Şablonlar Değil, Özel Kodlanmış Web Yazılımları?",
        content: "WordPress hazır temaları gibi hantal yapılar yüzlerce gereksiz eklenti ve kod yığını taşır; bu da sitenizin yavaş açılmasına, Google sıralamalarında gerilemesine ve güvenlik açıklarına neden olur. WE24 Agency, modern React/TypeScript mimarisiyle her satırı amaca yönelik yazılmış, saniyenin altında açılan ve asla hacklenemeyen temiz web siteleri üretir."
      }
    ],
    faqs: [
      {
        question: "Web sitemiz arama motorlarında (Google) nasıl üst sıralara çıkacak?",
        answer: "Yazdığımız her web sitesine semantik HTML5, JSON-LD Schema.org zengin veri şemaları, otomatik sitemap, optimize meta etiketleri ve 100/100 Core Web Vitals performans altyapısı standart olarak dahildir."
      },
      {
        question: "Web sitesini sonradan kendimiz güncelleyebilir miyiz?",
        answer: "Evet; kullanıcı dostu içerik yönetim paneli (CMS) entegrasyonu sağlıyoruz. Metinleri, fotoğrafları, yeni projeleri ve blog yazılarını teknik bilgiye ihtiyaç duymadan kolayca güncelleyebilirsiniz."
      }
    ],
    icon: "Code"
  }
];
